import { setCookie } from '@cian/utils/lib/browser/cookie';

import { MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE } from '../../../constants/mortgageRateHikeBanner';
export { MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE };

export function setMortgageRateHikeBannerClosed(): void {
  setCookie(MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE, '1', {
    expires: 365 * 24 * 60 * 60,
    secure: false,
  });
}
